<template>
  <base-page-layout id="industry_offer_page_access" title="Ofertas de Trade" :check-all-units-on-init="false">
    <div class="tabs-button-header">
      <mf-tabs-menu v-model="tab" :tabs="tabs" @input="navigateToRouteTab" />
    </div>

    <router-view></router-view>
  </base-page-layout>
</template>

<script>
import BasePageLayout from '@/components/BasePageLayout.vue'

export default {
  name: 'OfferSales',
  components: {
    BasePageLayout,
  },
  data: () => ({
    tab: 0,
  }),
  computed: {
    tabs() {
      return [
        {
          name: 'Propostas da indústria',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Ofertas aceitas',
          itemsLength: 0,
          haveLength: false,
        },
        {
          name: 'Histórico',
          itemsLength: 0,
          haveLength: false,
        },
      ]
    },
  },
  watch: {
    $route() {
      this.matchTabWithRoute()
    },
  },
  mounted() {
    this.matchTabWithRoute()
  },
  methods: {
    navigateToRouteTab() {
      switch (this.tab) {
        case 0:
          if (this.$route.name !== 'ofertas-trade-propostas') this.$router.push({ name: 'ofertas-trade-propostas' })
          break
        case 1:
          if (this.$route.name !== 'ofertas-trade-aceitas') this.$router.push({ name: 'ofertas-trade-aceitas' })
          break
        case 2:
          if (this.$route.name !== 'ofertas-trade-historico') this.$router.push({ name: 'ofertas-trade-historico' })
          break
        default:
          break
      }
    },
    matchTabWithRoute() {
      switch (this.$route.name) {
        case 'ofertas-trade-aceitas':
          this.tab = 1
          break
        case 'ofertas-trade-historico':
          this.tab = 2
          break
        case 'ofertas-trade-propostas':
        default:
          this.tab = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs-button-header {
  position: relative;
  margin-bottom: 20px;
  .button-new {
    position: absolute;
    top: 5px;
    right: 0;
  }
}
</style>
